'use strict';

// import $ from 'jquery';
import { defaultOptions } from '../tippy-util';
import {getOptionsFromDataset} from "../../../util/dom";

/**
 * @param {JQuery} $trigger
 * @param {JQuery} $container
 * @param {JQuery} $content
 * @param menuDirection
 * @param {Partial<import('tippy.js').Props>} options
 */
export default async ($trigger, $container, $content, menuDirection, options) => {

	// Import the tippy lib lazily
	const { default: tippy } = await import('tippy.js');

	// @ts-ignore
	const instance = tippy($trigger[0], {

		// Merge with default config
		...defaultOptions,

		...getOptionsFromDataset($trigger[0], 'tippy', true),

		appendTo: 'parent',
		content: (reference) => $content[0],
		placement: 'right-start',
		popperOptions: {
			modifiers: [
				...defaultOptions.popperOptions.modifiers,
				{
					name: 'preventOverflow',
					enabled: true,
					options: {
						mainAxis: false,
						altAxis: true,
						boundary: menuDirection === 'vertical' ? 'document' : $container[0],
						padding: 0,
					},
				},
				{
					name: 'flip',
					enabled: true,
					options: {
						allowedAutoPlacements: ['left-start'],
						fallbackPlacements: ['left-start'],
						flipVariations: false,
						boundary: menuDirection === 'vertical' ? 'document' : $container[0],
					},
				},
				{
					name: 'applyMaxHeightOnBox',
					enabled: true,
					phase: 'beforeWrite',
					fn: (data) => {
						const tippyBox = $(data.state.elements.popper).find('.tippy-box')[0];
						tippyBox.style.maxHeight = ('calc(100vh - ' + data.state.elements.reference.getBoundingClientRect().top + 'px - 1rem)');
						tippyBox.style.overflowX = 'visible';
						tippyBox.style.overflowY = 'auto';
					},
				},
			],
		},
		onTrigger: (instance) => {
			$trigger.closest('li').addClass('menu-tree__item--opened');
		},
		onUntrigger: (instance) => {
			$trigger.closest('li').removeClass('menu-tree__item--opened');
		},

		// Merge with provided options
		...options
	});

	$trigger.data('instance', instance);

	return instance;
};
